// custom interstate UI components
import SellingPriceFieldWithDealerDiscounts from '../terms/common/SellingPriceField.interstate';
import DealerDiscountSlideOut from './DealerDiscountsSlideOut.interstate';
import { useDealerDiscountSlideOut } from './useDealerDiscountSlideOut';

const SellingPriceWithDealerDiscounts = () => {
    const { fieldKey, isSlideOutOpen, toggleSlideOut } = useDealerDiscountSlideOut();

    return (
        <>
            <SellingPriceFieldWithDealerDiscounts key={fieldKey} toggleSlideOut={toggleSlideOut} />
            {isSlideOutOpen && <DealerDiscountSlideOut show={isSlideOutOpen} onHide={toggleSlideOut} />}
        </>
    );
};

export default SellingPriceWithDealerDiscounts;
